/**
 * Apple Pay on the Web is no longer Safari-only. Since iOS 18 / macOS Sequoia
 * Apple opened it to third-party browsers (Chrome, Edge, Firefox), where the
 * shopper pays by scanning a code and confirming on their iPhone or iPad:
 * https://support.apple.com/guide/safari/apple-pay-in-third-party-browsers-ibrw9b779bd3/mac
 *
 * That handoff is not automatic though — COPYandPAY only paints an Apple Pay
 * button where the browser exposes ApplePaySession. So we offer Apple Pay
 * everywhere, and use this check to pick which flow to render inside the card:
 * the gateway widget natively, or our own pay.tygo.net QR everywhere else.
 */
export const hasNativeApplePay = (): boolean => {
    try {
        const session = (window as any).ApplePaySession;
        return Boolean(session && session.canMakePayments());
    } catch {
        // Safari throws here when the page is not served over https.
        return false;
    }
};
